import { render, staticRenderFns } from "./ManageClass.vue?vue&type=template&id=9278c75e"
import script from "../../services/teacher/manage-class.js?vue&type=script&lang=js&external"
export * from "../../services/teacher/manage-class.js?vue&type=script&lang=js&external"
import style0 from "../../assets/css/teacher/manage-class.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports